module.exports = "/build/web/svg/social/youtube.99a778ad133cd946ffede6fa995361fb.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/youtube.svg
// module id = 202
// module chunks = 24